<template>
  <UpdateField
    v-if="isRentalPrice"
    :value="item.rental_pricing?.monthly_rent"
    :isEdit="isEdit"
    :cancel="cancel"
    :open="open"
    @updateProperty="handleUpdate(item._id, $event)"
    :formatter="priceFormat"
    :rules="[numberRule]"
    prefix="$"
    :suffix="item?.rental_pricing?.currency || 'MXN'"
    hint="Solo números"
  >
    {{ priceFormat(item.rental_pricing?.monthly_rent) }}
  </UpdateField>
  <UpdateField
    v-else
    :value="item.pricing.price"
    :isEdit="isEdit"
    :cancel="cancel"
    :open="open"
    @updateProperty="handleUpdate(item._id, $event)"
    :formatter="priceFormat"
    :rules="[numberRule]"
    prefix="$"
    :suffix="item?.pricing?.currency || 'MXN'"
    hint="Solo números"
  >
    {{ priceFormat(item.pricing.price) }}
  </UpdateField>
</template>
<script>
export default {
  name: "FieldPrice",
  components: {
    UpdateField: () => import("./UpdateField.vue")
  },
  props: {
    role: String,
    item: { type: Object, required: true },
    cancel: { type: Function, default: () => {} },
    open: { type: Function, default: () => {} },
    isRentalPrice: { type: Boolean, default: false }
  },
  data() {
    return {
      numberRule: val => {
        if (val < 0) return "Ingresa un numero positivo";
        if (isNaN(val)) return "Ingresa un numero valido";
        if (!/^\d+(\.\d+)?$|^\.\d+$|^\d+\.$/.test(val))
          return "Ingresa solo numeros";
        return true;
      }
    };
  },
  computed: {
    isEdit() {
      return this.role === "admin" || this.role === "superadmin";
    },
    currency() {
      if (this.isRentalPrice)
        return this.item.rental_pricing?.currency || "MXN";
      else return this.item.pricing?.currency || "MXN";
    },

  },
  methods: {
    priceFormat(price) {
      const currency = this.currency;
      const status = this.item.contract_status || "indefinido";
      if (parseFloat(price) <= 0 || isNaN(price) || (status === "vendido" && !this.isRentalPrice)) {
        return "-";
      }
      return (
        "$" +
        parseFloat(price)
          // .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          .concat(" " + currency)
      );
    },
    handleUpdate(id, data) {
      this.$emit("updateProperty", { id, data });
    }
  }
};
</script>
<style lang=""></style>
